// extracted by mini-css-extract-plugin
module.exports = {"depositDetails":"Deposit_depositDetails__3y4VE","depositDetailsPreview":"Deposit_depositDetailsPreview__TtrpQ"};